import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import { ListItemsContext } from '../list-items-context'

import {
  ContainerContentLeft,
  ContainerContentColumn
} from '../../styled-components'

import { Confirm } from '../../../../atoms/icons/essentials'
import CheckboxComponent from '../../../../atoms/checkboxes'
import {
  checkboxVariantOptions,
  checkboxSizeOptions
} from '../../../../atoms/checkboxes/constants'

import RadioComponent from '../../../../atoms/radio'

import { IsLoading } from '../list-items-item'

import {
  listItemsCheckVariantOptions,
  listItemStateVariantOptions
} from '../../constants'

import LeftContainerLeadingIcon from './left-container-leading-icon'
import { isEmpty } from 'lodash'

const LeftContainerItem = ({
  leadingIcon,
  itemKey,
  state,
  stateStyle,
  loading,
  isCheck,
  onCheck
}) => {
  const { listViewType, checkComponent, handleSubmit } =
    useContext(ListItemsContext)
  const { checkInputType } = checkComponent || {}

  const handleCheckboxClick = (event) => {
    if (onCheck) {
      onCheck(event)
      return
    }

    handleSubmit?.(event)
  }

  if (!leadingIcon && isEmpty(checkInputType)) return null

  return (
    <ContainerContentLeft listViewVariant={listViewType}>
      {checkInputType && (
        <ContainerContentColumn>
          {checkInputType === listItemsCheckVariantOptions.CHECKBOX && (
            <IsLoading
              skeletonStyle={{
                width: '20px',
                height: '20px',
                borderRadius: '5px'
              }}
            >
              <CheckboxComponent.Root
                checked={isCheck}
                customOnClick={handleCheckboxClick}
                size={checkboxSizeOptions.MEDIUM}
                variant={checkboxVariantOptions.STANDARD}
                disabled={state === listItemStateVariantOptions.INACTIVE}
                isDimmed={
                  state === listItemStateVariantOptions['NON-HIGHLIGHTED']
                }
                name={itemKey}
              >
                <CheckboxComponent.Indicator>
                  <Confirm size="icon-s" />
                </CheckboxComponent.Indicator>
              </CheckboxComponent.Root>
            </IsLoading>
          )}
          {checkInputType === listItemsCheckVariantOptions.RADIO && (
            <IsLoading skeletonStyle={{ width: '20px', height: '20px' }}>
              <RadioComponent.Item
                value={`${itemKey}`}
                disabled={state === listItemStateVariantOptions.INACTIVE}
              >
                <RadioComponent.Indicator />
              </RadioComponent.Item>
            </IsLoading>
          )}
        </ContainerContentColumn>
      )}

      <LeftContainerLeadingIcon
        leadingIcon={leadingIcon}
        loading={loading}
        stateStyle={stateStyle}
        state={state}
      />
    </ContainerContentLeft>
  )
}

LeftContainerItem.propTypes = {
  checkComponent: PropTypes.shape({
    checkInputType: PropTypes.oneOf(
      Object.values(listItemsCheckVariantOptions)
    ),
    onChange: PropTypes.func,
    radioDefaultValue: PropTypes.string,
    radioCurrentSelection: PropTypes.string
  }),
  leadingIcon: PropTypes.node,
  itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  state: PropTypes.oneOf(Object.values(listItemStateVariantOptions)),
  stateStyle: PropTypes.object,
  loading: PropTypes.bool,
  isCheck: PropTypes.bool,
  onCheck: PropTypes.func
}

export default LeftContainerItem
